module.exports = __webpack_public_path__ + "img/gentlemen-club-story-2.8ddc924e.png";